import { GetAllMuscles } from '../../anatomy/get-all-muscles.js';
import { RG_TYPE } from '../../types/rg-type.js';
import { getRgObjectsOfType } from '../../utils/get-rg-objects-of-type.js';
import { getRgVersions } from '../../utils/internal/get-versions.js';
import { apartmentToDto } from './internal/apartment/apartment-to-dto.js';
import { buildingToDto } from './internal/building/building-to-dto.js';
import { setBuildingIndexes } from '../../utils/set-building-indexes.js';

/**
 * Get an `RgObjectDto` from an `RgObject`.
 * @param top (internal) add `versions` to this DTO. You only want to do this on top level
 * @returns
 */
function rgObjectToDto({ rgObj, top = true, partial, versions = getRgVersions() }) {
    if (!partial && rgObj.type === RG_TYPE.Building)
        return buildingToDto(rgObj, top, versions);
    if (!partial && rgObj.type === RG_TYPE.Apartment)
        return apartmentToDto(rgObj, top, true, versions);
    const dtoObj = {
        ...rgObj,
        templateUuid: undefined,
        hash: undefined,
        parent: undefined,
        children: partial?.children ?? rgObj.children.map(c => rgObjectToDto({ rgObj: c, top: false, versions })),
        dto: true,
        rg: undefined,
        ...partial
    };
    if (top) {
        dtoObj.versions = versions;
        dtoObj.templates = [];
        const savedUnits = [];
        const buildings = getRgObjectsOfType(rgObj, RG_TYPE.Building);
        const muscleUnits = buildings.flatMap(b => GetAllMuscles(b.data.anatomy)).flatMap(m => m.gFUnits);
        const apartments = getRgObjectsOfType([rgObj, ...muscleUnits], RG_TYPE.Apartment);
        for (const apartment of apartments) {
            if (savedUnits.includes(apartment.name))
                continue;
            const apartmentDto = apartmentToDto(apartment, false, false, versions);
            dtoObj.templates.push(apartmentDto);
            savedUnits.push(apartmentDto.name);
        }
        setBuildingIndexes(rgObj);
    }
    return dtoObj;
}

export { rgObjectToDto };
//# sourceMappingURL=rg-object-to-dto.js.map
